import { 
  POST_NEW_INVITATION_CODE,
  GET_INVITATION_CODES,
  DELETE_INVITATION_CODE,
  POST_REQUEST_INVITATION,
  GET_INVITATION_CODE_DETAILS } from '@/services/invitationCodes'

const postNewInvitationCode = (_, data) => {
  return POST_NEW_INVITATION_CODE(data)
}

const postRequestInvitation = (_, data) => {
  return POST_REQUEST_INVITATION(data)
}


const getInvitationCodes = () => {
  return GET_INVITATION_CODES()
}

const deleteInvitationCode = (_, invitationCodeId) => {
  return DELETE_INVITATION_CODE(invitationCodeId)
}

const getInvitationCodeDetails = (_, invitationCodeId) => {
  return GET_INVITATION_CODE_DETAILS(invitationCodeId)
}

export default {
  postNewInvitationCode,
  getInvitationCodes,
  postRequestInvitation,
  deleteInvitationCode,
  getInvitationCodeDetails
}
